import { onBeforeUnmount, ref, watch } from 'vue';

export const useRowFitCount = (containerRef) => {
  const fitCount = ref(Infinity);
  let observer = null;

  const measure = (container) => {
    const itemWidth = container.firstElementChild?.getBoundingClientRect().width;
    if (!itemWidth) return;

    const gap = parseFloat(getComputedStyle(container).columnGap) || 0;
    fitCount.value = Math.max(1, Math.floor((container.clientWidth + gap) / (itemWidth + gap)));
  };

  const disconnect = () => {
    observer?.disconnect();
    observer = null;
  };

  watch(
    containerRef,
    (container) => {
      disconnect();
      if (!container) return;

      observer = new ResizeObserver(() => measure(container));
      observer.observe(container);
    },
    { immediate: true, flush: 'post' }
  );

  onBeforeUnmount(disconnect);

  return fitCount;
};
